'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reset;
exports.resetState = resetState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESET_STATE = 'reset/RESET_STATE';

var initialState = {
  reset: false
};

function reset() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case RESET_STATE:
      return (0, _extends3.default)({}, state, {
        reset: true
      });
    default:
      return state;
  }
}

function resetState() {
  return {
    type: RESET_STATE
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reset.js
// module id = 385
// module chunks = 0